import { render, staticRenderFns } from "./car-sweepstakes-widget-overlay.vue?vue&type=template&id=64e52faa&scoped=true&lang=pug"
import script from "./car-sweepstakes-widget-overlay.vue?vue&type=script&lang=js"
export * from "./car-sweepstakes-widget-overlay.vue?vue&type=script&lang=js"
import style0 from "./car-sweepstakes-widget-overlay.scss?vue&type=style&index=0&id=64e52faa&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e52faa",
  null
  
)

export default component.exports